import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this suitable for supervisors in different industries?',
  a: 'The prompts are designed around broadly applicable supervisory tasks such as planning, communication, reporting, delegation, meetings, and follow-up. You should adapt the terminology, examples, and procedures to your particular industry and organization.'
}, {
  q: 'Do I need to be an AI expert?',
  a: 'No. The system is designed around ready-to-use instructions and customizable fields. You can start with a prompt, enter your context, review the output, and refine it as needed.'
}, {
  q: 'Which AI tools can I use?',
  a: 'The prompts are designed for use with ChatGPT, Claude, Gemini, and DeepSeek. Results may vary by platform, model, available features, and the information you provide.'
}, {
  q: 'Does the system replace my judgment as a supervisor?',
  a: 'No. It is a practical support resource for organizing tasks and preparing drafts. You remain responsible for decisions, approvals, procedures, and the accuracy of any material you use.'
}, {
  q: 'Is this a physical product?',
  a: 'No. This is a digital product. Your materials are delivered electronically, so no physical shipment is required.'
}, {
  q: 'Is this a one-time payment?',
  a: 'Yes. The advertised offer is a one-time payment of $27 USD, with access to the purchased materials. There is no recurring subscription associated with this offer.'
}, {
  q: 'How do I receive the product?',
  a: 'After your purchase is successfully processed, follow the delivery instructions provided at checkout to access your digital materials.'
}, {
  q: 'Can I use AI-generated content directly in official reports?',
  a: "You should review and verify all AI-generated content before use. Follow your organization's documentation standards, confidentiality requirements, and approval procedures."
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-41" data-mp="2kveu8x7ic4le">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-42" data-mp="2fwtt8vkflgvw">
        <h2 className="text-center font-display text-3xl font-black uppercase text-plum sm:text-4xl" data-id="element-43" data-mp="2ay0r1zalhcb1">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape-soft/30 overflow-hidden rounded-2xl border border-grape-soft/50 bg-white" data-id="element-44" data-mp="38kzgboyyjhyw">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-45" data-mp="2ylicld39ne5k" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-46" data-mp="2um01f918yhfx">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-47" data-mp="3utwqmibqgdb5">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-48" data-mp="2q3x0lzd7ili" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-49" data-mp="2qx4jp65ec4p" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="7of8f15b615u">
                  <div className="overflow-hidden" data-id="element-51" data-mp="hf0d96bks1x7">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-52" data-mp="he8ke39d4iam">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}